// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body[data-theme=dark]{color:#fff}`, "",{"version":3,"sources":["webpack://./features/theme-toggle/ui/themes/_dark.sass"],"names":[],"mappings":"AAEA,sBAEE,UAJW","sourcesContent":["$text-color: #ffffff\n\nbody[data-theme='dark']\n  //background-color: $secondary-blue-dark\n  color: $text-color\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
